import { render, staticRenderFns } from "./AlarmModal.vue?vue&type=template&id=68c2bf24&"
import script from "./AlarmModal.vue?vue&type=script&lang=js&"
export * from "./AlarmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports